import { MenuBar } from '@go-client/components';
import { BubbleButton, BubbleOverlay } from '@go-client/components/BubbleUI';
import { BrandLogo } from '@go-client/components/UIkit/Brand/BrandLogo/BrandLogo';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { getHelpCategories } from '@go-client/lib/api/docs';
import { HelpCategory } from '@go-shared/types/help';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import Page from './Page';
import PageWrapper from './PageWrapper';

type HelpPageProps = RouteComponentProps;

export default function Help(props: HelpPageProps) {
  const { brand } = useServerInfo();

  const [loading, setLoading] = useState(false);
  const [helpCategories, setHelpCategories] = useState<HelpCategory[]>([]);

  useEffect(() => {
    fetchData().catch(console.error);
  }, []);

  async function fetchData() {
    setLoading(true);

    try {
      const hc = await getHelpCategories();
      setHelpCategories(hc);
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageWrapper {...props}>
      <Page className="Help absolute flex items-stretch">
        <MenuBar {...props} />
        <div className="HelpContent bg-blue-lightest overflow-y-auto flex-grow">
          <div
            className="HelpHeader align-with-logo flex items-end sticky top-0
                left-0 z-10 bg-white shadow"
          >
            <BrandLogo logo={brand.logo} />
            <div className="flex-grow px-5 flex items-end">
              <div className="mb-3">
                <BubbleButton
                  appearance="triangular"
                  variant="navy"
                  className="text-base-i w-48 pl-5-i text-left mx-3"
                >
                  Help Desk
                </BubbleButton>
              </div>
            </div>
          </div>
          <div className="HelpBody mx-10 content-minus-logo min-w-900 text-center">
            <div className="py-8 mx-auto inline-block text-left" style={{ minWidth: '75%' }}>
              <div className="flex items-center mb-3">
                <h1 className="text-slate text-2xl mr-auto">Tutorials</h1>
                <BubbleButton
                  icon="envelope"
                  linkProps={{
                    to: {
                      pathname:
                        'mailto:support@sparkcooperative.com?subject=%5BYour%20Full%20Name%5D%20-%20%5BCompany%5D%20-%20%5BDate%5D%3A%20Assistance%20Request%20for%20GO%20Software&body=Thank%20you%20for%20contact%20the%20GO%20Software%20Help%20Desk!%20%0A%0AIn%20order%20to%20better%20serve%20you%2C%20please%20provide%20the%20following%20information%20in%20your%20email%3A%0A%0ARequester%3A%20%5BYour%20Full%20Name%20%26%20Title%5D%0A%0AContact%20Email%3A%20%5BYour%20Contact%20Email%5D%0A%0AIssue%2FQuestion%20Description%3A%20%0A%5BProvide%20a%20brief%20and%20clear%20description%20of%20your%20issue%20or%20question%20here.%5D%0A%0AProperty%20Information%3A%20%0A%5BSpecify%20the%20relevant%20details%20about%20the%20property%20you%20are%20referring%20to%2C%20such%20as%20property%20or%20ship%20name.%5D',
                    },
                    target: '_blank',
                  }}
                  variant="ocean"
                >
                  Email Spark
                </BubbleButton>
              </div>
              <BubbleOverlay loading={loading}>
                <div className="p-8 bg-white shadow rounded overflow-hidden">
                  <div>
                    Also available at:{' '}
                    <BubbleButton
                      variant="ocean"
                      inverse
                      className="p-0-i"
                      linkProps={{
                        to: { pathname: 'https://docs.sparkcooperative.com/' },
                        target: '_blank',
                      }}
                    >
                      https://docs.sparkcooperative.com/
                    </BubbleButton>
                  </div>
                  {helpCategories.length > 0 && (
                    <div className="grid grid-cols-1 gap-8 mt-8">
                      {helpCategories.map(hc => (
                        <div key={hc.name}>
                          <h1 className="text-lg font-semibold text-navy uppercase mb-3">
                            {hc.name}
                          </h1>
                          <ul>
                            {hc.items.map(it => (
                              <li key={it.name}>
                                <BubbleButton
                                  variant="ocean"
                                  inverse
                                  linkProps={{ to: it.path, target: '_blank' }}
                                >
                                  <span className="text-ocean-darkest">{it.name}</span>
                                </BubbleButton>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </BubbleOverlay>
            </div>
          </div>
        </div>
      </Page>
    </PageWrapper>
  );
}
